import React, { useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import ServicesAlgo from './pages/ServicesAlgo';
import Footer from './components/Footer';
import { Route, Routes, useLocation } from 'react-router-dom';
import ServicesBacktest from './pages/ServicesBacktest';
import ServicesCustomisedSol from './pages/ServicesCustomisedSol';
import OurProject from './pages/OurProject';
import ProjectDetails from './components/projects/projectDetails/ProjectDetails';
import Team from './pages/Team';
import Contact from './pages/Contact';

function App() {
  // SCROLL TO TOP
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  // SCROLL TO TOP
  return (
    <React.Fragment>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services/algo-trading" element={<ServicesAlgo />} />
        <Route path="/services/backtesting" element={<ServicesBacktest />} />
        <Route path="/projects" element={<OurProject />} />
        <Route path="/projects/project-details" element={<ProjectDetails />} />
        <Route path="/team" element={<Team />} />
        <Route path="/contact" element={<Contact />} />
        <Route
          path="/services/customised-solution"
          element={<ServicesCustomisedSol />}
        />
      </Routes>
      <Footer />
    </React.Fragment>
  );
}

export default App;
